import axios from 'axios';
import {
    errorResponse,
    validateApiData
} from '../../utils/validators/validators';
import { SERVER_URL } from '../../utils/config/constants';
import { getCookies } from '../../utils/getToken';

export const serviceProvider = async params => {
    var authToken = getCookies();
    try {
        const { data } = await axios({
            method: 'post',
            data: params,
            url: `${SERVER_URL}/provider-service/list`,
            headers: { 'x-auth-token': authToken }
        });
        return validateApiData(data) ? data : errorResponse;
    } catch (e) {
        return errorResponse;
    }
};

export const allProviderListing = async params => {
    var authToken = getCookies();
    try {
        const { data } = await axios({
            method: 'get',
            url: `${SERVER_URL}/user/search?text=${' '}&type=${1}&filter=${
                params.filter
            }&featured=${params.featured}`,
            headers: { 'x-auth-token': authToken }
        });
        return validateApiData(data) ? data : errorResponse;
    } catch (e) {
        return errorResponse;
    }
};
export const providerFilterListing = async params => {
    var authToken = getCookies();

    try {
        const { data } = await axios({
            method: 'get',

            url: `${SERVER_URL}/user/search?text=${params.text}&type=${
                params.type
            }&featured=${params.featured}&filter=${params.filter}`,
            headers: { 'x-auth-token': authToken }
        });
        return validateApiData(data) ? data : errorResponse;
    } catch (e) {
        return errorResponse;
    }
};

export const searchProviderListing = async params => {
    var authToken = getCookies();
    try {
        const { data } = await axios({
            method: 'get',
            url: `${SERVER_URL}/user/search?text=${params.text}&type=${
                params.type
            }&featured=${params.featured}&filter=${params.filter}`,
            headers: { 'x-auth-token': authToken }
        });
        return validateApiData(data) ? data : errorResponse;
    } catch (e) {
        return errorResponse;
    }
};

export const serviceProviderList = async params => {
    var authToken = getCookies();
    try {
        const { data } = await axios({
            method: 'post',
            data: params,
            url: `${SERVER_URL}/provider-service/list`,
            headers: { 'x-auth-token': authToken }
        });
        return validateApiData(data) ? data : errorResponse;
    } catch (e) {
        return errorResponse;
    }
};
export const featuredList = async params => {
    var authToken = getCookies();
    try {
        const { data } = await axios({
            method: 'get',
            params: params,
            url: `${SERVER_URL}/user/featured-providers`,
            headers: { 'x-auth-token': authToken }
        });
        return validateApiData(data) ? data : errorResponse;
    } catch (e) {
        return errorResponse;
    }
};

export const recentList = async params => {
    var authToken = getCookies();
    try {
        const { data } = await axios({
            method: 'get',
            params: params,
            url: `${SERVER_URL}/user/recent-providers`,
            headers: { 'x-auth-token': authToken }
        });
        return validateApiData(data) ? data : errorResponse;
    } catch (e) {
        return errorResponse;
    }
};

export const bestRatedProvider = async () => {
    var authToken = getCookies();
    try {
        const { data } = await axios({
            method: 'get',
            url: `${SERVER_URL}/provider/best-rated`,
            headers: { 'x-auth-token': authToken }
        });
        return validateApiData(data) ? data : errorResponse;
    } catch (e) {
        return errorResponse;
    }
};

export const getInboxList = async () => {
    var authToken = getCookies();
    try {
        const { data } = await axios({
            method: 'get', //you can set what request you want to be
            url: `${SERVER_URL}/inbox/my`,
            headers: {
                'x-auth-Token': authToken
            }
        });
        return validateApiData(data) ? data : errorResponse;
        // If data is not valid
    } catch (e) {
        console.log(e);
        return errorResponse;
    }
};

export const uploadProCompletionImg = async (params) => {
    console.log("completion IMAGE PARAMS 1111",params)
        var authToken = getCookies();
        try {
            const { data } = await axios({
                method: 'post', //you can set what request you want to be
                url: `${SERVER_URL}/booking/add-image`,
                data: params,
                headers: {
                    'x-auth-Token': authToken
                }
            });
            console.log("completion IMAGE DATA 2222",data);
            return validateApiData(data) ? data : errorResponse;
            // If data is not valid
        } catch (e) {
            console.log(e);
            return errorResponse;
        }
    };


// WEBPACK FOOTER //
// ./src/apiHelpers/provider/list.js